import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-auth-inner',
  templateUrl: './auth-inner.component.html',
  styleUrls: ['./auth-inner.component.scss']
})
export class AuthInnerComponent implements OnInit {

  constructor(
    public themeService: ThemeService,
    ) { }

  ngOnInit(): void {
  }

}
